import React from "react";
import { Link } from "react-router-dom";
import { useComplaintModal } from "../context/ComplaintModalContext";
import { useAuth } from "../context/AuthContext";

export default function Footer() {
  const { openComplaint } = useComplaintModal();
  const { user } = useAuth();
  return (
    <footer className="mt-auto bg-brand text-white">
      {/* Rodapé em DUAS COLUNAS que se completam em altura: a navegação é uma linha só e os contatos são
          três, o que deixava um vão à esquerda e empurrava o texto legal para uma faixa própria embaixo.
          Trazendo o aviso, o copyright e o CNPJ para debaixo dos links, o vão vira conteúdo e o rodapé
          encurta — sem esconder nada do que a LGPD exige mostrar. */}
      <div className="mx-auto max-w-6xl px-4 md:px-6 py-8">
        <div className="flex flex-col gap-6 md:flex-row md:items-start md:justify-between md:gap-10">
          {/* A coluna cresce com o espaço disponível; quem tem limite de largura é o TEXTO, não os links.
              Com max-w na coluna, os 8 itens da navegação quebravam em duas linhas. */}
          <div className="md:flex-1">
          <nav className="flex flex-wrap gap-x-6 gap-y-2 font-medium">
            <Link to="/" className="text-white/85 hover:text-white">Início</Link>
            {user?.tipo !== 1 && <button type="button" onClick={() => openComplaint()} className="text-white/85 hover:text-white">Reclamar</button>}
            <Link to="/empresas" className="text-white/85 hover:text-white">Empresas</Link>
            <Link to="/guia/como-saber-se-uma-empresa-da-retorno" className="text-white/85 hover:text-white">Guia do candidato</Link>
            <Link to="/selo" className="text-white/85 hover:text-white">Selo eaiRH</Link>
            <Link to="/como-funciona" className="text-white/85 hover:text-white">Sobre</Link>
            <Link to="/termos" className="text-white/85 hover:text-white">Termos de Uso</Link>
            <Link to="/privacidade" className="text-white/85 hover:text-white">Privacidade</Link>
          </nav>

            <p className="mt-4 text-xs leading-relaxed text-white/70">
              Este site não tem vínculo com nenhuma empresa mencionada. Todas as informações
              são de responsabilidade dos usuários que as publicam. O eaiRH apenas hospeda os
              relatos e oferece às empresas o direito de resposta.
            </p>
            {/* Identificação da entidade responsável. Existe por dois motivos: a LGPD exige controlador
                identificável (o portal trata currículo e relato de candidato), e empresa que recebe um
                pedido de direito de resposta precisa saber quem está do outro lado. */}
            <p className="mt-2 text-xs text-white/50">
              © {new Date().getFullYear()} eaiRH — Reputação em processos seletivos.
              <span className="mx-2 text-white/25">·</span>
              eaiRH Consultoria — CNPJ 68.961.696/0001-56
            </p>
          </div>

          <div className="space-y-3 text-sm text-white/85">
            <p className="flex items-center gap-2">
              <span aria-hidden>✉️</span> contato@eairh.com.br
            </p>
            <div className="flex flex-col gap-2">
              <a
                href="https://www.instagram.com/eairh.oficial/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram do eaiRH (@eairh.oficial)"
                className="flex items-center gap-2 text-white/85 transition hover:text-white"
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
                  <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
                  <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
                  <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
                </svg>
                <span>Instagram <span className="text-white/60">@eairh.oficial</span></span>
              </a>
              <a
                href="https://www.linkedin.com/company/eairh-oficial/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="LinkedIn do eaiRH"
                className="flex items-center gap-2 text-white/85 transition hover:text-white"
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
                  <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z" />
                  <rect x="2" y="9" width="4" height="12" />
                  <circle cx="4" cy="4" r="2" />
                </svg>
                <span>LinkedIn</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
